import { forwardRef } from "react";

import { Combobox as ComboboxPrimitive } from "@base-ui/react";

interface SelectAnchorProps {
  isSearchable: boolean;
  className?: string;
  dataTestId?: string;
  children: React.ReactNode;
}

export const SelectAnchor = forwardRef<HTMLDivElement, SelectAnchorProps>(
  ({ isSearchable, className, dataTestId, children }, ref) => {
    if (isSearchable) {
      return (
        <div
          ref={ref}
          className={className}
          {...(dataTestId ? { "data-testid": dataTestId } : {})}
        >
          {children}
        </div>
      );
    }

    return (
      <ComboboxPrimitive.Trigger
        nativeButton={false}
        render={props => (
          <div
            {...props}
            ref={ref}
            className={className}
            {...(dataTestId ? { "data-testid": dataTestId } : {})}
          />
        )}
      >
        {children}
      </ComboboxPrimitive.Trigger>
    );
  }
);

SelectAnchor.displayName = "SelectAnchor";
